import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type Field from 'modules/custom_resources/store/models/customResources/Field'

interface Props {
  field: Field | CustomField | null | undefined
  title?: string
  description?: string
  onSubmit: () => void
  onClose: () => void
}
interface DeleteProps {
  onSubmit: () => void
}

const DeleteButton = ({ onSubmit }: DeleteProps) => {
  return (
    <Button type="negative" onClick={onSubmit}>
      {i18n.t('custom_fields.actions.delete.confirm_delete')}
    </Button>
  )
}

const DeleteModal = ({ onClose, onSubmit, field, title, description }: Props) => {
  if (!field) return null

  const label = field.attributes.label

  return (
    <Modal
      illustration="delete"
      title={title || i18n.t('custom_fields.actions.delete.title')}
      description={
        description ||
        i18n.t('custom_fields.actions.delete.description', {
          label: label,
        })
      }
      footer={<DeleteButton onSubmit={onSubmit} />}
      onClose={onClose}
    />
  )
}

export default DeleteModal
